import { Outlet } from "react-router-dom";
import FillView from "../components/fillView/FillView";
import Header from "../components/header/Header";
import MaintenanceModeBanner from "../components/MaintenanceModeBanner/MaintenanceModeBanner";

const DefaultLayout = () => {
  return (
    <FillView>
      <Header />
      <MaintenanceModeBanner />
      <Outlet />
    </FillView>
  );
};

export default DefaultLayout;
